// N2 (2026-05-08, ALGORITHM_FLOW v0.49) — /inventory 단일 페이지 + tab state.
//   본질 design 2 layer 분리:
//     "현재재고" 탭 = provider_item_mirror (= 박스히어로 raw)
//     "재료" 탭     = inventory (= dvvb 자체)
//     "자동발주" 탭 = 자동발주 영역
//
//   옛 router-based SubNav + Outlet (= /inventory/low /inventory/auto 별 라우트) 폐기.
//   단일 component 안 tab state 영역 영역.

import { useState } from 'react';
import { PageHeader } from '../../components/chrome';
import { SubNav, type SubNavItem } from '../../components/primitives';
import { useViewport } from '../../lib/useViewport';
import { CurrentTab } from './current';
import { MaterialsTab } from './low';
import { AutoTab } from './auto';
import { SuppliersTab } from './suppliers';

type TabId = 'current' | 'materials' | 'suppliers' | 'auto';

const SUB_ITEMS: SubNavItem[] = [
  { id: 'current', label: '현재재고' },
  { id: 'materials', label: '재료' },
  { id: 'auto', label: '자동발주' },
  { id: 'suppliers', label: '거래처' },
];

export function InventoryLayout() {
  const [active, setActive] = useState<TabId>('current');
  const viewport = useViewport();
  const isMobile = viewport === 'mobile';

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        minWidth: 0,
      }}
    >
      <div
        style={{
          marginLeft: 'calc(var(--page-pad-x) * -1)',
          marginRight: 'calc(var(--page-pad-x) * -1)',
          minWidth: 0,
        }}
      >
        <PageHeader
          viewport={viewport}
          title="재고"
          date="실시간"
        >
          <span />
        </PageHeader>
      </div>
      <SubNav
        items={SUB_ITEMS}
        active={active}
        onChange={(id) => setActive(id as TabId)}
        style={{ alignSelf: 'flex-start', maxWidth: '100%' }}
        scrollable={isMobile}
      />
      {active === 'current' && <CurrentTab />}
      {active === 'materials' && <MaterialsTab />}
      {active === 'suppliers' && <SuppliersTab />}
      {active === 'auto' && <AutoTab />}
    </div>
  );
}
